var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-ppt';
                    var viewUrl = 'gfx/sprite.svg#view-icon-ppt';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };